import { Box } from '@hivebrite/design-system/Box';

import GoToGroupButton from './GoToGroupButton';
import JoinButton from './JoinButton';

const TopicActions = ({ topic }) => (
  <>
    {!topic?.closed && (
      <Box flex={1} key="join-button" mt={3} mx={4}>
        <JoinButton />
      </Box>
    )}
    <Box flex={1} key="go-to-group-button" mt={3} mx={4}>
      <GoToGroupButton />
    </Box>
  </>
);

export default TopicActions;
